<template>
  <v-slide-y-transition mode="out-in">
    <v-layout row wrap>
      <v-flex lg12 sm12 xs12 class="tabular">
        <v-expansion-panel v-model="panel" flat class="elevation-0 ma-0" expand>
          <v-expansion-panel-content v-bind:key="1" class="grey lighten-4">
            <div slot="header" >Information Graphic</div>
            <v-card>
              <v-card-text class="pa-0">
                <v-layout row wrap>
                  <v-flex lg9 sm8 xs12 class="pa-2">                                                
                    <template>
                      <v-layout row wrap v-if="show">
                        <v-flex lg7 sm7 xs12>
                          <template>
                            <e-chart :key="'a'+(data.time+data.id)" v-if="!quickcountMode" v-bind:option="setBar1Option(data)" height="250px" width="100%"/>                  
                            <e-chart :key="'b'+(data.time+data.id)" v-else v-bind:option="setBar1Option(data, true)" height="250px" width="100%"/>                                                         
                          </template>
                        </v-flex>
                        <v-flex lg5 sm5 xs12>
                          <template>
                            <e-chart :key="'c'+(data.time+data.id)" v-if="!quickcountMode" v-bind:option="setPie2Option(partais)" height="250px" width="100%"/>                  
                            <e-chart :key="'d'+(data.time+data.id)" v-else v-bind:option="setPie2Option(partais, true)" height="250px" width="100%"/>                                                         
                          </template>
                        </v-flex>
                      </v-layout>                  
                      <table style="width:100%">
                        <tr>
                          <td class="text-xs-left"><span class="title blue--text"><v-icon color="blue">accessibility</v-icon> {{data.sah.sah?data.sah.sah:0}}</span>/<small>{{data.pt?data.pt:0}} &nbsp; telah memilih</small></td>
                          <td class="text-xs-right"><small>tidak sah </small><span class="title red--text">{{data.sah.tdk_sah?data.sah.tdk_sah:0}}  <v-icon color="red">layers_clear</v-icon></span></td>
                        </tr>                        
                      </table>            
                      <v-divider></v-divider>
                      <table style="width:100%">
                        <tr>
                          <td class="text-xs-left"><span class="subheading" :class="colorPersen(persenContain(data.contain))+'--text'"><v-icon small :color="colorPersen(persenContain(data.contain))">trending_up</v-icon> {{persenContain(data.contain)}}% </span> to complete</td></td>
                          <td class="text-xs-right"><v-chip :color="kompetisi.color" small dark>
                            <v-avatar><v-icon small>alarm</v-icon></v-avatar>
                            <small>{{data.sah.updated_at?$moment(data.sah.updated_at*1000).fromNow():null}}</small></v-chip></td></td>
                        </tr>                        
                      </table>     
                    </template>
                  </v-flex>
                  <v-flex lg3 sm4 xs12 class="tabular">                        
                    <v-data-table style="max-height: 332px; overflow-y: auto"
                      :headers="[  
                        {text:'No',value:'index',sortable:false},
                        {text:'Urut',sortable:false,value:'no',align:'center'},
                        {text:'',value:'i',sortable:false},
                        {text:'Suara',value:'value'},
                        {text:'Seats',value:'seats'}
                      ]"
                      :items="partais"  
                      :pagination.sync="pagination"
                      hide-actions
                      >
                      <template slot="items" slot-scope="props">                             
                        <tr class="cursor" :style="props.item.seats>0?'background:#D4FFD4':''" @click="openDialog({partai_id:props.item.id})">      
                          <td>{{props.index+1}}</td>
                          <td>
                            <v-chip :color="props.item.color" dark>{{props.item.no}}</v-chip>                                  
                          </td>
                          <td>
                            <v-avatar size="35">
                              <img :src="props.item.thumb ? props.item.thumb :require('@/assets/img/avatar/blank-dpd.jpg')">
                            </v-avatar>
                          </td>                          
                          <td>
                            <span v-if="!quickcountMode">{{props.item.value?props.item.value:0}}</span>
                            <span v-else>{{props.item.hitung.quickcount?props.item.hitung.quickcount:0}}</span>
                          </td>
                          <td>{{props.item.seats}}</td>
                        </tr>
                      </template>
                    </v-data-table>                                                
                  </v-flex>
                </v-layout>            
              </v-card-text>
            </v-card>            
          </v-expansion-panel-content>  
          <v-expansion-panel-content v-bind:key="2" class="grey lighten-3">
            <div slot="header" >Sainte Lague (kuota {{data.kuota}} seats)</div>
            <v-card>
              <v-card-text class="pa-0">
                <div class="v-table__overflow tabular">   
                  <table id="sainte">
                    <thead>
                      <tr>
                        <th rowspan="2">No.</th>
                        <th rowspan="2">Partai</th>
                        <th :colspan="kuota">Sainte Lague</th>
                        <th rowspan="2">Seats Won(*)</th>                
                      </tr>
                      <tr>
                        <th v-for="(i) in kuota">{{i}}</th>
                      </tr>  
                    </thead>
                    <tbody v-if="show">
                      <tr v-for="(calon,j) in partais" >
                        <td class="text-xs-center">{{calon.no}}</td>
                        <td class="text-xs-center cursor" @click="openDialog({partai_id:calon.id})">
                          <v-avatar size="35">
                            <img :src="calon.thumb ? calon.thumb :require('@/assets/img/avatar/blank-dpd.jpg')">
                          </v-avatar>
                        </td>
                        <td v-for="(t,i) in kuota" v-bind:class="maxIndex[i] === j?'success white--text':''" class="text-xs-center">
                          <small>{{origin[i][j]}} / {{pembagi[i][j]}}</small><br/>                  
                          <strong>{{result[i][j]}}</strong>                  
                        </td>
                        <td class="text-xs-center title">{{calon.seats}}</td>
                      </tr>
                    </tbody>
                  </table>          
                </div>  
              </v-card-text>
            </v-card>              
          </v-expansion-panel-content>
        </v-expansion-panel>  
        
      </v-flex>
    </v-layout>      
  </v-slide-y-transition>
</template>

<script>  
import EChart  from '@/components/chart/echart';    
import DBar1   from '../../components/data-chart/bar-1';
import DPie2   from '../../components/data-chart/pie-2';
  
export default {  
  name: 'sainte-lague',  
  components: {
      EChart
  },    
  props:{
    kompetisi : Object,
    data  : Object,   
    quickcountMode : {
      type: Boolean,
      default: true,
    },
  },  
  data: () => ({        
    panel : [true, false],
    pagination : {'sortBy': 'value', 'descending': true, 'rowsPerPage': -1}, 
    partais : [],
    kuota   : 0,
    
    origin  : [],
    pembagi : [],
    result  : [],        
    
    maxIndex : [],
    
    show : false    
  }),  
  mounted(){ },
  created(){
     
  },
  asyncComputed: {
    refresh(){      
      this.init();      
      return;
    }    
  },
  watch: {
    quickcountMode(newVal){      
      this.init();  
    }
  },
  methods: {  
    openDialog(data){
      this.$emit('openDialog', data);
    },
    
    init(){
      this.partais = this.data.calons;
      this.kuota   = this.data.kuota;
      let calons = this.partais;            
      let seats = [];
      
      calons.forEach((calon,j)=>{
        seats[j] = 0;
      });
      
      var imax = -1; 
      var vmax =  0;
      console.log(calons)
      for(var i=0; i<this.kuota; i++){
        this.origin[i]  = [];
        this.pembagi[i] = [];
        this.result[i]  = [];                             
        calons.forEach((calon,j)=>{             
          var ori = i === 0 ? this.quickcountMode ? calon.hitung.quickcount :calon.value?calon.value:0 : this.origin[i-1][j];
          var per = i === 0 ? 1 : this.pembagi[i-1][j]; 
          
          if(imax === j){
            per = parseInt(this.pembagi[i-1][j]+2);            
          }
          
          this.origin[i][j] = ori;                    
          this.pembagi[i][j]= per;
          this.result[i][j] = parseFloat(ori/per).toFixed(1);                    
          vmax += ori;
        });
        imax = this.indexOfMax(this.result[i]);                
        seats[imax] += vmax > 0 ? 1 : 0;
        this.maxIndex[i] = vmax > 0 ? imax : -1;
      }
            
      calons.forEach((calon,j)=>{
         this.partais[j].seats = seats[j];
      });
      
      this.show = true;
    },
    
    indexOfMax(arr) {
        if (arr.length === 0) {
            return -1;
        }

        var max = parseFloat(arr[0]);
        var maxIndex = 0;

        for (var i = 1; i < arr.length; i++) {
            if (parseFloat(arr[i]) > parseFloat(max)) {
                maxIndex = i;
                max = parseFloat(arr[i]);
            }
        }

        return maxIndex;
    },
    
    setBar1Option(data, quickcountMode=false){            
        let newOption  = JSON.parse(JSON.stringify(DBar1.option));
        let seriesData = [], legendData = []; this.calons = [];        
        data.calons.forEach(item=>{
            var value = quickcountMode?item.hitung.quickcount:item.hitung.suara;          
            var name  = item.no+'. '+item.akronim;
            seriesData.push({name:name, value:value, itemStyle: {color:item.color}});
            legendData.push(item.no);                
        });
        newOption.series[0].data = seriesData;   
        newOption.xAxis[0].data  = legendData;        
        newOption.toolbox.show   = false;      
        //console.log(newOption);
        return newOption;
    },
    
    setPie2Option(data, quickcountMode=false){            
        let newOption  = JSON.parse(JSON.stringify(DPie2.option));
        let seriesData = [], legendData = []; this.calons = []; let totSeats = 0;       
        data.forEach(item=>{
            totSeats += item.seats;
            var value = item.seats;          
            var name  = item.no+'. '+item.akronim;
            seriesData.push({name:name, value:value, itemStyle: {color:item.color}});
            legendData.push(name);                
        });
        newOption.series[0].radius = ['40%','90%'];
        if(totSeats > 0){
          newOption.series[0].data = seriesData;   
        } else {
          newOption.series[0].data = [];   
        }
        newOption.legend.data    = legendData;      
        //console.log(newOption);
        return newOption;
    },
    
    persenContain(contain){
        return (contain.done/contain.all*100).toFixed(2)
    },

    colorPersen(persen){
        if(persen >= 0 && persen <=40)return 'red';
        else if(persen <=60)return 'orange';
        else if(persen <=80)return 'yellow';
        else if(persen <=99)return 'blue';
        else return 'green';        
    },
  }  
}
</script>
<style>
#sainte{border-collapse: collapse; width:100%}
#sainte th, #sainte td{border:1px solid #eee; padding:3px}
#sainte th{text-align: center}
</style>